import { WSFilter } from "@wingspanhq/fe-component-library";
import { PayrollRunCycleType } from "@wingspanhq/wingspan-api-sdk";

import { PAYROLL_RUNS_STATUS_FILTER_OPTIONS } from "../../../constants";

import { PAYROLLS_CYCLE_FILTER_ALL } from "./types";

export function buildPayrollsFiltersConfig(): WSFilter[] {
  return [
    {
      title: "Status",
      name: "status",
      type: "checkbox",
      options: PAYROLL_RUNS_STATUS_FILTER_OPTIONS.map(option => ({
        name: option.label,
        label: option.label
      }))
    },
    {
      title: "Cycle",
      name: "cycleType",
      type: "radio",
      options: [
        { name: PAYROLLS_CYCLE_FILTER_ALL, label: "All", hidePill: true },
        { name: PayrollRunCycleType.ON_CYCLE, label: "On-cycle" },
        { name: PayrollRunCycleType.OFF_CYCLE, label: "Off-cycle" }
      ]
    }
  ];
}
